import { Link } from 'gatsby';
import React from 'react';
import { withPrefix } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import { Icon } from '../../common_ui/Icon';
import { useLongPress } from '@/hooks/useLongPress';
import { useMultiTap } from '@/hooks/useMultiTap';
import { useDebugMode } from '@/hooks/precon-supporter';
import * as styles from './PreconSupporterFooter.module.css';

type Props = {
  courseId?: 'basic' | 'advanced';
};

const PreconSupporterFooter: React.FC<Props> = ({ courseId = 'basic' }) => {
  const basePath =
    courseId === 'advanced'
      ? '/precon-supporter/yousei-kouza/e-learning/advanced'
      : '/precon-supporter/yousei-kouza/e-learning';

  const { isDebugModeEnabled, enableDebugMode, disableDebugMode } =
    useDebugMode();

  // 3秒長押しで有効化
  const longPressHandlers = useLongPress({
    threshold: 3000,
    onLongPress: enableDebugMode,
  });

  // 3回素早くタップで無効化
  const multiTapHandlers = useMultiTap({
    tapCount: 3,
    maxInterval: 500,
    onMultiTap: disableDebugMode,
  });

  // デバッグモードが有効なときは解除用のトリプルタップ、無効なときは有効化用の長押し
  const copyrightHandlers = isDebugModeEnabled
    ? { onClick: multiTapHandlers.onClick }
    : longPressHandlers;

  return (
    <div className={styles.root}>
      <footer className={styles.footer}>
        <div className={styles.container}>
          <nav className={styles.nav}>
            <Link className={styles.navLink} to={`${basePath}/`}>
              講座一覧
              <Icon type='arrow-filled-right' />
            </Link>
            <Link className={styles.navLink} to={`${basePath}/qa/`}>
              受講に関するQ&amp;A
              <Icon type='arrow-filled-right' />
            </Link>
            <Link className={styles.navLink} to={`${basePath}/contact/`}>
              お問い合わせ
              <Icon type='arrow-filled-right' />
            </Link>
            <a
              href={withPrefix('/')}
              target='_blank'
              rel='noopener noreferrer'
              className={styles.navLink}
            >
              ポータルサイトTOPに戻る
              <Icon type='arrow-filled-right' />
            </a>
          </nav>
          <div className={styles.logo}>
            <a
              href='https://www.cfa.go.jp/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <StaticImage
                src='../../../../static/img/cfg.png'
                alt='こども家庭庁'
                width={375}
                height={130}
                placeholder='blurred'
              />
            </a>
          </div>
        </div>
        <div className={styles.copyright}>
          <small
            {...copyrightHandlers}
            style={{ userSelect: 'none', WebkitUserSelect: 'none' }}
          >
            Copyright © Children and Families Agency, All Rights reserved.
          </small>
        </div>
      </footer>
    </div>
  );
};

export default PreconSupporterFooter;
